import React, { useContext } from 'react';
import classNames from 'classnames';
import { PAMBeaconButton, PAMBeaconModal } from '../../utils/beacon';
import navigationContext from '../../context/navigationContext';

import styles from './ExternalLinks.module.scss';
import TRP from './TRP';
import { getCookieValue } from '../../utils/browserUtils';

type Props = {
  opacityClassName?: string;
  divClassName?: string;
  linkClassName?: string;
  iconClassName?: string;
  colorClassName?: string;
  labelClassName?: string;
  retailEnabled?: boolean;
};

type Link = {
  key: string;
  label?: string;
  icon?: React.FunctionComponent<SvgIconProps>;
};

const ExternalLinks: React.FunctionComponent<Props> = ({
  opacityClassName,
  divClassName,
  colorClassName,
  retailEnabled
}) => {
  const { urls } = useContext(navigationContext);
  const handleAccountAccessClick = (key: string) => {
    const modal = document.getElementById(key) ?? null;
    if (modal !== null) {
      // @ts-ignore
      modal.show();
    }
  };

  const externalLinks: Link[] = [
    {
      key: 'individualInvestor'
    }
  ];

  const handleAccountClick = (key: string) => {
    const modal = document.getElementById(key) ?? null;

    // If cookie (client-portal=true) is set, change target url to client-portal.
    if (getCookieValue(document.cookie, 'client-portal') === 'true') {
      window.location.href = urls.clientPortalDashboard;
    } else {
      window.location.href = urls.individualInvestor;
    }

    if (modal !== null) {
      // @ts-ignore
      modal.close();
    }
  };

  return (
    <div className={classNames(styles['external-links'], divClassName)}>
      {externalLinks.map((link: Link, index) => {
        const showLink =
          link.key === 'individualInvestor' && !retailEnabled ? false : true;
        return (
          showLink && (
            <div key={index}>
              <PAMBeaconButton
                variant="secondary"
                icon-align="left"
                scale="tertiary"
                onClick={() =>
                  handleAccountAccessClick('accountAccessBeaconModal')
                }
                label="Personal Investing Dashboard">
                <svg
                  // @ts-ignore
                  slot="icon"
                  className={classNames(
                    styles['exit-icon'],
                    styles['external-icon'],
                    opacityClassName
                  )}
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg">
                  <g stroke="none" fill="none">
                    <g
                      transform="translate(-1059.000000, -26.000000)"
                      className={classNames(
                        styles['exit-icon-color'],
                        colorClassName
                      )}>
                      <g transform="translate(1060.000000, 27.000000)">
                        <g>
                          <polyline points="13 17 13 21 0 21 0 0 13 0 13 4" />
                          <path d="M5,11.5 L23,11.5" />
                          <polyline points="18 6 23 11 18 16" />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </PAMBeaconButton>
            </div>
          )
        );
      })}

      <PAMBeaconModal id={'accountAccessBeaconModal'} closeOnClickOut={true}>
        <svg
          // @ts-ignore
          slot="logo"
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none">
          <g clip-path="url(#clip0_882_787488)">
            <path
              d="M62.3368 64V63.1588C62.7005 56.0771 59.9392 51.525 51.8786 48.8331L60.4332 44.1629V2.04688H1.51562V52.5276L13.8987 51.0658C13.8987 51.0658 11.3233 52.6387 16.9916 60.0502C17.7604 61.2443 18.2576 62.5926 18.4482 64"
              fill="white"></path>
            <path
              d="M0 0L0.000881778 64H18.4482C18.2576 62.5927 17.7604 61.2444 16.9916 60.0503C13.9422 56.5589 14.6635 51.6213 15.3137 52.3679C15.9667 53.2722 16.931 53.9032 18.0211 54.1396C16.6444 51.563 15.8001 48.7358 15.5386 45.8262C15.5386 33.8052 19.9959 29.3017 19.9959 29.3017C19.9959 29.3017 20.3579 24.4513 19.7382 24.3284C18.3128 24.0472 16.4865 22.8298 16.4865 21.2433C15.7606 21.2074 15.0358 21.3317 14.3634 21.6073C13.691 21.8829 13.0874 22.303 12.5956 22.838C12.1037 23.373 11.7357 24.0096 11.5174 24.7028C11.2992 25.396 11.2362 26.1287 11.3328 26.8489C11.3212 27.3405 11.5026 27.8171 11.8381 28.1766C12.1737 28.5361 12.6367 28.7498 13.1279 28.7721C14.233 28.7721 14.6375 28.0655 14.6375 27.0832C14.624 26.9235 14.646 26.7628 14.702 26.6126C14.758 26.4624 14.8466 26.3264 14.9614 26.2145C15.0762 26.1026 15.2143 26.0175 15.3659 25.9653C15.5174 25.9132 15.6787 25.8952 15.838 25.9127C16.2052 25.9127 16.9204 26.0655 16.9204 28.1931C16.989 28.8831 16.9062 29.5797 16.6778 30.2344C16.4494 30.8891 16.0808 31.486 15.5979 31.9835C15.1149 32.481 14.5292 32.8671 13.8816 33.1149C13.234 33.3626 12.5401 33.4661 11.8484 33.418C8.93612 33.418 5.09676 31.2617 5.09676 24.0354C5.18803 20.7469 6.52715 17.6162 8.84232 15.2789C11.1575 12.9416 14.2753 11.5727 17.5628 11.4502C17.0051 11.5665 16.4788 11.8011 16.0194 12.1381C15.2155 12.745 14.4895 13.4489 13.8579 14.2336C14.1966 14.2519 14.534 14.2896 14.8683 14.3465C15.1278 14.3907 15.3941 14.3701 15.6437 14.2866C15.8933 14.2031 16.1183 14.0592 16.2989 13.8678C16.678 13.4473 17.0834 13.0512 17.5125 12.682C18.1035 12.2374 18.7804 11.9204 19.5003 11.7509C20.2202 11.5815 20.9674 11.5633 21.6947 11.6976C22.114 11.7701 22.5202 11.8582 22.9187 11.9658C21.7986 12.1022 20.7307 12.5176 19.8127 13.1737C18.9857 13.7924 18.2248 14.4948 17.542 15.2697C17.542 15.2697 17.9499 15.495 18.193 15.6343C18.4547 15.7326 18.7392 15.7534 19.0124 15.6939C19.2856 15.6345 19.5358 15.4974 19.7329 15.2992C20.1524 14.8758 20.6027 14.4841 21.0801 14.1273C21.8011 13.5052 22.6934 13.1156 23.6397 13.0097C24.5861 12.9039 25.5424 13.0866 26.383 13.534C26.5194 13.6238 26.6548 13.7202 26.7893 13.8165C25.6131 13.9634 24.4756 14.3332 23.4378 14.9059C22.3819 15.5688 21.4199 16.3706 20.5776 17.2897C20.5776 17.2897 20.9681 17.6004 21.1834 17.7715C21.4338 17.9144 21.7249 17.969 22.0101 17.9265C22.2952 17.884 22.5578 17.7469 22.7556 17.5372C23.2418 17.0637 23.7661 16.6311 24.3233 16.2437C25.4811 15.4759 26.8246 15.0345 28.2121 14.9659C28.6488 15.39 28.8093 15.7593 29.2286 15.7593C29.6852 15.7593 30.0038 15.4091 30.377 14.9273C31.4153 14.9266 32.428 15.25 33.2737 15.8523C33.7149 16.1097 34.1308 16.4082 34.5159 16.7438C35.0888 17.2225 35.522 17.1239 35.778 16.8705C35.9716 16.6778 36.2702 16.334 36.2702 16.334C35.6273 15.5787 34.8463 14.953 33.969 14.4903C33.1703 14.0348 32.2652 13.799 31.3458 13.807C31.5194 13.6456 31.702 13.494 31.8926 13.3531C32.4896 13.0663 33.1532 12.947 33.8126 13.0076C34.4721 13.0683 35.1027 13.3068 35.6373 13.6977C36.0691 13.927 36.4615 14.2239 36.7996 14.577C36.9455 14.7317 37.1387 14.8336 37.3487 14.8667C37.5588 14.8997 37.7739 14.8621 37.9603 14.7598C38.1534 14.6039 38.3687 14.4778 38.5991 14.3856C38.0141 13.6117 37.2583 12.9833 36.3908 12.5492C35.8689 12.2925 35.3042 12.1339 34.725 12.0813C35.551 11.891 36.4041 11.8484 37.245 11.9554C40.935 12.4529 42.0401 16.5415 41.81 20.1114C41.4237 26.0889 41.6286 27.5325 43.0696 27.5398C43.4156 27.5222 43.7425 27.376 43.9864 27.13C44.2303 26.8839 44.3736 26.5557 44.3881 26.2095C44.5053 25.4508 44.7275 24.8532 45.2171 24.8532C46.2258 24.8532 46.461 25.8215 46.461 26.4539C46.461 30.4423 43.8925 31.2469 41.6885 31.2469C39.4836 31.2469 37.7918 29.5351 37.198 26.5806C37.0097 25.6391 36.8639 24.699 36.8639 24.699C36.5449 24.772 36.2372 24.8876 35.949 25.0427C35.3812 25.3275 34.8031 25.6964 34.8031 25.6964C34.8031 25.6964 35.4273 27.1582 35.5618 27.5771C35.591 28.3741 35.5369 29.172 35.4004 29.9577C37.8097 33.8247 39.0571 38.3025 38.994 42.8581C38.994 50.3148 36.2285 57.1335 34.3335 59.6691C34.8956 59.5421 35.4267 59.3046 35.896 58.9703C37.672 57.2333 38.1235 56.8983 39.9923 56.7324C41.1816 53.6231 41.5982 49.7871 40.4038 41.0907C47.1954 45.8512 47.4011 49.8356 46.4367 54.189C50.6979 52.011 48.3109 47.7219 48.3109 47.7219C49.3466 48.413 50.4449 49.0056 51.5912 49.4919C59.4931 52.728 62.3368 56.9868 62.3368 63.1587V64H64V0H0Z"
              fill="#05C3DE"></path>
            <path
              d="M33.4411 29.8709C33.0799 29.8318 33.0704 29.8145 33.0695 28.9169C33.0687 28.2147 33.4437 28.2025 34.1043 28.3935C34.1781 27.9499 34.3959 26.6504 33.8647 26.6504C33.4654 26.6504 33.159 26.962 32.6346 26.962C32.02 26.962 30.8204 26.5454 30.4064 26.5454C29.626 26.5454 30.0271 27.9139 30.0271 28.456C31.58 28.2529 32.2258 28.0245 32.2258 28.7502C32.2258 29.9647 32.4255 29.7719 30.468 29.9422C29.455 30.0289 28.8786 30.0819 28.2736 30.0958C28.2736 30.0958 27.7015 27.8101 28.0027 27.3531C28.5158 26.5722 29.086 25.8303 29.7085 25.1335C30.0739 24.7233 30.0739 24.7233 29.8881 24.1577C29.6346 23.3947 28.6459 20.3773 28.6459 20.3773C28.5701 19.9684 28.5882 19.5475 28.6987 19.1466C28.8092 18.7456 29.0093 18.375 29.284 18.0626C29.4594 17.8208 29.3335 17.721 29.1521 17.8087C28.1781 18.2788 26.6286 19.2853 26.6885 20.6369C26.7354 21.712 26.278 21.5466 25.4637 21.3586C24.7706 21.1667 24.0468 21.1117 23.3326 21.1968C22.2519 21.3834 21.5913 22.166 21.7355 22.9186C21.8631 23.5874 22.4456 24.1929 24.1487 24.1929C25.7971 24.1929 25.9751 23.1894 26.7129 24.5132C27.3422 25.6369 27.8674 25.9755 26.9777 26.8644C24.7684 29.0749 24.6911 28.3561 24.6911 30.6027C24.6911 32.9717 27.1989 34.8337 28.5643 34.4014C29.7085 34.1446 30.8288 33.7912 31.9133 33.345C31.9888 33.2894 31.9741 33.1062 31.8699 33.1045C31.3864 33.0993 29.5227 33.108 29.3777 32.4326C29.2319 31.7564 29.1234 31.2555 29.1234 31.2555C30.2081 31.0517 31.3106 30.9578 32.4142 30.9752C33.0319 30.9799 33.6488 31.0187 34.2623 31.0915C34.3738 30.7484 34.4295 30.3897 34.4272 30.0289C34.102 29.9563 33.7727 29.9035 33.4411 29.8709Z"
              fill="#05C3DE"></path>
            <path
              d="M33.7163 23.5212C34.0121 23.6799 34.3394 23.7712 34.6747 23.7884C35.01 23.8057 35.345 23.7485 35.6555 23.621C36.8787 23.2048 37.0218 21.7989 35.6798 21.5676C34.6347 21.3875 34.2996 21.9313 33.6617 21.3363C33.2163 20.9222 32.9308 20.6392 32.62 20.3384C32.4829 20.2074 32.3475 20.1036 32.2797 20.1288C32.2103 20.1535 32.1808 20.2364 32.2693 20.4469C32.6396 21.5207 33.1248 22.5515 33.7163 23.5212Z"
              fill="#05C3DE"></path>
            <path
              d="M53.7164 39.1692C54.319 39.1741 54.9067 39.3574 55.4052 39.696C55.9037 40.0346 56.2907 40.5134 56.5173 41.0718C56.7439 41.6303 56.7999 42.2433 56.6784 42.8336C56.5568 43.4238 56.263 43.9648 55.8342 44.3882C55.4053 44.8116 54.8606 45.0985 54.2689 45.2125C53.6771 45.3266 53.0648 45.2627 52.5093 45.029C51.9538 44.7953 51.4801 44.4022 51.1478 43.8994C50.8156 43.3966 50.6398 42.8067 50.6426 42.204C50.6423 41.8021 50.7219 41.4042 50.8768 41.0333C51.0316 40.6624 51.2587 40.326 51.5447 40.0436C51.8307 39.7613 52.1699 39.5386 52.5428 39.3884C52.9156 39.2383 53.3145 39.1638 53.7164 39.1692Z"
              fill="white"></path>
            <path
              d="M53.7818 39.6181C53.2626 39.5982 52.7494 39.7342 52.3082 40.0086C51.867 40.2829 51.518 40.6831 51.3062 41.1575C51.0943 41.6319 51.0294 42.1589 51.1197 42.6705C51.2099 43.1822 51.4513 43.6551 51.8127 44.0284C52.174 44.4017 52.6389 44.6582 53.1473 44.765C53.6558 44.8718 54.1846 44.824 54.6656 44.6276C55.1466 44.4313 55.5579 44.0955 55.8464 43.6634C56.1349 43.2313 56.2875 42.7228 56.2844 42.2032C56.2943 41.868 56.2369 41.5342 56.1157 41.2215C55.9944 40.9088 55.8118 40.6236 55.5785 40.3826C55.3453 40.1417 55.0661 39.9499 54.7575 39.8186C54.4489 39.6873 54.1172 39.6191 53.7818 39.6181ZM54.7037 43.9949L53.7315 42.4628H53.1455V43.9949H52.5908V40.4315H53.9702C54.8174 40.4315 55.2158 40.7666 55.2158 41.4515C55.2236 41.5781 55.2049 41.705 55.161 41.824C55.1171 41.943 55.0488 42.0516 54.9606 42.1428C54.8724 42.234 54.7662 42.3059 54.6488 42.3538C54.5313 42.4017 54.4051 42.4246 54.2783 42.4211L55.2983 43.9949H54.7037Z"
              fill="#05C3DE"></path>
            <path
              d="M54.6537 41.4278C54.6537 40.9546 54.2457 40.8809 53.8697 40.8809H53.1362V42.0163H53.7135C54.2049 42.0163 54.6537 41.9894 54.6537 41.4278Z"
              fill="#05C3DE"></path>
          </g>
          <defs>
            <clipPath id="clip0_882_787488">
              <rect width="64" height="64" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>

        <div className="beacon-modal__title">
          Private Asset Management Accounts
        </div>
        <div className="beacon-modal__description">
          If your account is related to an Investment Advisory account for which
          you have delegated investment discretion to <TRP />, please refrain
          from effecting transactions in this account. If you would like to
          amend the investment guidelines for your Investment Advisory account,
          or otherwise direct <TRP />, please contact your Investment Liaison.
        </div>
        <div className={styles.actionZone}>
          <PAMBeaconButton
            label="I accept the terms of this agreement"
            link-target="_blank"
            onClick={() => {
              handleAccountClick('accountAccessBeaconModal');
            }}
          />
        </div>
      </PAMBeaconModal>
    </div>
  );
};

export default ExternalLinks;
